// Default React, React Components, Router and Services Components
import React, { useEffect, useState } from "react";
import {
  Box,
  Checkbox,
  Chip,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import moment from "moment";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { getMonth } from "utils/helper";

// Importing Custom Components
import MaterialUIButton from "components/commonComponents/button/button";
import MultipleAutocomplete from "components/commonComponents/autocomplete/multipleAutocomplete";

// Importing useStyles
import useStyles from "./qcReports.styles";

// Import Material Icons
import CloseIcon from "@mui/icons-material/Close";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import EventBusyOutlinedIcon from "@mui/icons-material/EventBusyOutlined";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import RestartAltOutlinedIcon from "@mui/icons-material/RestartAltOutlined";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import AlertDialog from "components/commonComponents/alertDialog";
import DoneIcon from "@mui/icons-material/Done";
import { countryDropdown, makeString } from "redux/manageissues/action";
import {
  filterBAU,
  getBAU,
  getCountrySource,
  getMakeSource,
  setBauFilter,
} from "redux/app/actions";
import { getBauStatus } from "redux/reports/actions";
import {
  bauIdDropdown,
  finalAutoQcDropdown,
  finalTableDropdown,
  getBauFilters,
  logMonthDropdown,
  makeDropdown,
  oemIdDropdown,
  qcStatusDropdown,
  regionBAUDropdown,
  uploadedDropdown,
  uploadedStatusDropdown,
  utfStatusDropdown,
} from "redux/qcreports/action";
import { qcReports, statusCode } from "utils/enums";
function AdvanceFilterBau(props) {
  // Declaration of States and Component Variables Start Here
  const [selectedValue, setSelectedValue] = React.useState("Year");
  const months = getMonth();
  const [show, setShow] = useState(false);
  const id = useSelector((state) => state.project.reports);
  const select = useSelector((state) => state.qcreports.filterBau);
  const classes = useStyles();
  const dispatch = useDispatch();
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const [bauid, setBauid] = React.useState([]);
  const [oemId, setOemId] = React.useState([]);
  const [make, setMake] = React.useState([]);
  const [region, setRegion] = React.useState([]);
  const [uploaded, setUploaded] = React.useState([]);
  const [utf8Status, setUtf8Status] = React.useState([]);
  const [qcStatus, setQcStatus] = React.useState([]);
  const [uploadStatusServiceBus, setUploadStatusServiceBus] = React.useState(
    []
  );
  const [finalAutoQC, setFinalAutoQC] = React.useState([]);
  const [pushedToFinalTable, setPushedToFinalTable] = React.useState([]);
  const [logMonth, setLogMonth] = React.useState([]);
  // Declaration of States and Component Variables End Here
  useEffect(() => {
    getDataFormAPIForDropdown();
  }, []);
  const formik = useFormik({
    initialValues: {
      bauId: select.bauId,
      oemId: select.oemId,
      make: select.make,
      region: select.region,
      uploaded: select.uploaded,
      utf8Status: select.utf8Status,
      qcStatus: select.qcStatus,
      uploadStatusServiceBus: select.uploadStatusServiceBus,
      finalAutoQC: select.finalAutoQC,
      pushedToFinalTable: select.pushedToFinalTable,
      logMonth: select.logMonth,
      exportId: select.exportId,
    },

    onSubmit: (values) => {
      dispatch(setBauFilter(values));
      props.filter({
        bauId: values.bauId.map((e) => e),
        oemId: values.oemId.map((e) => e),
        make: values.make.map((e) => e),
        region: values.region.map((e) => e),
        uploaded: values.uploaded.map((e) => e),
        utf8Status: values.utf8Status.map((e) => e),
        qcStatus: values.qcStatus.map((e) => e),
        uploadStatusServiceBus: values.uploadStatusServiceBus.map((e) => e),
        finalAutoQC: values.finalAutoQC.map((e) => e),
        pushedToFinalTable: values.pushedToFinalTable.map((e) => e),
        logMonth: values.logMonth.map((e) => e),
        exportId: [],
      });
    },
  });

  /******************************************************************************
  Function: reset
  Argument:
  Return:
  Usage:
  1.To reset the form values
  *******************************************************************************/

  const reset = () => {
    if (formik && formik.values) {
      //formik.resetForm();
      formik.values.bauId = [];
      formik.values.oemId = [];
      formik.values.make = [];
      formik.values.region = [];
      formik.values.uploaded = [];
      formik.values.utf8Status = [];
      formik.values.qcStatus = [];
      formik.values.uploadStatusServiceBus = [];
      formik.values.finalAutoQC = [];
      formik.values.pushedToFinalTable = [];
      formik.values.logMonth = [];
      formik.values.exportId = [];

      props.filter(
        {
          bauId: [],
          oemId: [],
          make: [],
          region: [],
          uploaded: [],
          utf8Status: [],
          qcStatus: [],
          uploadStatusServiceBus: [],
          finalAutoQC: [],
          pushedToFinalTable: [],
          logMonth: [],
          exportId: [],
        },
        true
      );
      dispatch(
        setBauFilter({
          bauId: [],
          oemId: [],
          make: [],
          region: [],
          uploaded: [],
          utf8Status: [],
          qcStatus: [],
          uploadStatusServiceBus: [],
          finalAutoQC: [],
          pushedToFinalTable: [],
          logMonth: [],
          exportId: [],
        })
      );
    }
  };
  /******************************************************************************
  Function: getDataFormAPIForDropdown
  Argument:
  Return:
  Usage:
  1.To Call dropdown API 
  *******************************************************************************/

  const getDataFormAPIForDropdown = () => {
    dispatch(getBauFilters(id)).then((res) => {
      if (res.status === statusCode.success) {
        if (res.data === qcReports.noRecordsFound) {
          setRegion([]);
          setBauid([]);
          setOemId([]);
          setMake([]);
          setUploaded([]);
          setUtf8Status([]);
          setQcStatus([]);
          setUploadStatusServiceBus([]);
          setFinalAutoQC([]);
          setPushedToFinalTable([]);
          setLogMonth([]);
        } else {
          setRegion(res.data?.region);
          setBauid(res.data?.bauId);
          setOemId(res.data?.oemId);
          setMake(res.data?.make);
          setUploaded(res.data?.uploaded);
          setUtf8Status(res.data?.utf8Status);
          setQcStatus(res.data?.qcStatus);
          setUploadStatusServiceBus(res.data?.uploadStatusServiceBus);
          setFinalAutoQC(res.data?.finalAutoQC);
          setPushedToFinalTable(res.data?.pushedToFinalTable);
          setLogMonth(res.data?.logMonth);
        }
      } else {
        setRegion([]);
        setBauid([]);
        setOemId([]);
        setMake([]);
        setUploaded([]);
        setUtf8Status([]);
        setQcStatus([]);
        setUploadStatusServiceBus([]);
        setFinalAutoQC([]);
        setPushedToFinalTable([]);
        setLogMonth([]);
      }
    });
  };

  return (
    // Advance Filter Form Start Here
    <Box>
      <Grid
        container
        spacing={2.5}
        alignItems="center"
        justifyContent="flex-start"
      >
        {/* Popup Title Start Here */}
        <Grid item xs={12}>
          <Grid
            container
            spacing={0}
            alignItems="center"
            justifyContent="flex-start"
          >
            <Grid item xs>
              <Typography variant="h6" gutterBottom>
                Advance Filter
              </Typography>
            </Grid>

            <Grid item xs={"auto"} textAlign="right">
              <Grid
                container
                spacing={0}
                alignItems="center"
                justifyContent="flex-start"
              >
                <Grid item xs="auto">
                  <MaterialUIButton
                    color="secondary"
                    message="RESET"
                    onClick={() => {
                      reset();
                    }}
                    startIcon={<RestartAltOutlinedIcon />}
                  />
                </Grid>
                <Grid item xs="auto">
                  <Tooltip title="Close " placement="bottom" arrow>
                    <IconButton
                      onClick={() => {
                        JSON.stringify(formik.initialValues) ===
                        JSON.stringify(formik.values)
                          ? props.close()
                          : setShow(true);
                      }}
                      color="secondary"
                      aria-label="Close"
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <MultipleAutocomplete
            labelId="Status"
            id="status"
            name="bauId"
            label="BAU ID"
            onChange={(_, e) => {
              formik.setFieldValue("bauId", e);
            }}
            isOptionEqualToValue={(option, value) => {
              return option === value;
            }}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  size="small"
                  variant="outlined"
                  label={option}
                  //{...getTagProps({ index })}
                />
              ))
            }
            value={formik.values.bauId}
            placeholder="bauId"
            limitTags={3}
            options={bauid}
            getOptionLabel={(e) => e}
            renderOption={(props, e, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={icon}
                  size="small"
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {e}
              </li>
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <MultipleAutocomplete
            labelId="Status"
            id="status"
            name="oemId"
            label="OEM ID"
            onChange={(_, e) => {
              formik.setFieldValue("oemId", e);
            }}
            isOptionEqualToValue={(option, value) => {
              return option === value;
            }}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  size="small"
                  variant="outlined"
                  label={option}
                  //{...getTagProps({ index })}
                />
              ))
            }
            value={formik.values.oemId}
            placeholder="oemId"
            limitTags={3}
            options={oemId}
            getOptionLabel={(e) => e}
            renderOption={(props, e, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={icon}
                  size="small"
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {e}
              </li>
            )}
          />
        </Grid>{" "}
        <Grid item xs={12}>
          <MultipleAutocomplete
            labelId="Status"
            id="status"
            name="make"
            label="Make"
            onChange={(_, e) => {
              formik.setFieldValue("make", e);
            }}
            isOptionEqualToValue={(option, value) => {
              return option === value;
            }}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  size="small"
                  variant="outlined"
                  label={option}
                  //{...getTagProps({ index })}
                />
              ))
            }
            value={formik.values.make}
            placeholder="make"
            limitTags={3}
            options={make}
            getOptionLabel={(e) => e}
            renderOption={(props, e, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={icon}
                  size="small"
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {e}
              </li>
            )}
          />
        </Grid>{" "}
        <Grid item xs={12}>
          <MultipleAutocomplete
            labelId="Status"
            id="status"
            name="region"
            label="Region"
            onChange={(_, e) => {
              formik.setFieldValue("region", e);
            }}
            isOptionEqualToValue={(option, value) => {
              return option === value;
            }}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  size="small"
                  variant="outlined"
                  label={option}
                  //{...getTagProps({ index })}
                />
              ))
            }
            value={formik.values.region}
            placeholder="region"
            limitTags={3}
            options={region}
            getOptionLabel={(e) => e}
            renderOption={(props, e, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={icon}
                  size="small"
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {e}
              </li>
            )}
          />
        </Grid>{" "}
        <Grid item xs={12}>
          <MultipleAutocomplete
            labelId="Status"
            id="status"
            name="uploaded"
            label="Uploaded"
            onChange={(_, e) => {
              formik.setFieldValue("uploaded", e);
            }}
            isOptionEqualToValue={(option, value) => {
              return option === value;
            }}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  size="small"
                  variant="outlined"
                  label={option}
                  //{...getTagProps({ index })}
                />
              ))
            }
            value={formik.values.uploaded}
            placeholder="uploaded"
            limitTags={3}
            options={uploaded}
            getOptionLabel={(e) => e}
            renderOption={(props, e, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={icon}
                  size="small"
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {e}
              </li>
            )}
          />
        </Grid>{" "}
        <Grid item xs={12}>
          <MultipleAutocomplete
            labelId="Status"
            id="status"
            name="utf8Status"
            label="UTF 8 Status"
            onChange={(_, e) => {
              formik.setFieldValue("utf8Status", e);
            }}
            isOptionEqualToValue={(option, value) => {
              return option === value;
            }}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  size="small"
                  variant="outlined"
                  label={option}
                  //{...getTagProps({ index })}
                />
              ))
            }
            value={formik.values.utf8Status}
            placeholder="utf8Status"
            limitTags={3}
            options={utf8Status}
            getOptionLabel={(e) => e}
            renderOption={(props, e, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={icon}
                  size="small"
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {e}
              </li>
            )}
          />
        </Grid>{" "}
        <Grid item xs={12}>
          <MultipleAutocomplete
            labelId="Status"
            id="status"
            name="qcStatus"
            label="QC Status"
            onChange={(_, e) => {
              formik.setFieldValue("qcStatus", e);
            }}
            isOptionEqualToValue={(option, value) => {
              return option === value;
            }}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  size="small"
                  variant="outlined"
                  label={option}
                  //{...getTagProps({ index })}
                />
              ))
            }
            value={formik.values.qcStatus}
            placeholder="qcStatus"
            limitTags={3}
            options={qcStatus}
            getOptionLabel={(e) => e}
            renderOption={(props, e, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={icon}
                  size="small"
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {e}
              </li>
            )}
          />
        </Grid>{" "}
        <Grid item xs={12}>
          <MultipleAutocomplete
            labelId="Status"
            id="status"
            name="uploadStatusServiceBus"
            label="Upload Status"
            onChange={(_, e) => {
              formik.setFieldValue("uploadStatusServiceBus", e);
            }}
            isOptionEqualToValue={(option, value) => {
              return option === value;
            }}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  size="small"
                  variant="outlined"
                  label={option}
                  //{...getTagProps({ index })}
                />
              ))
            }
            value={formik.values.uploadStatusServiceBus}
            placeholder="upload Status Service Bus"
            limitTags={3}
            options={uploadStatusServiceBus}
            getOptionLabel={(e) => e}
            renderOption={(props, e, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={icon}
                  size="small"
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {e}
              </li>
            )}
          />
        </Grid>{" "}
        <Grid item xs={12}>
          <MultipleAutocomplete
            labelId="Status"
            id="status"
            name="finalAutoQC"
            label="Final Auto QC"
            onChange={(_, e) => {
              formik.setFieldValue("finalAutoQC", e);
            }}
            isOptionEqualToValue={(option, value) => {
              return option === value;
            }}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  size="small"
                  variant="outlined"
                  label={option}
                  //{...getTagProps({ index })}
                />
              ))
            }
            value={formik.values.finalAutoQC}
            placeholder="finalAutoQC"
            limitTags={3}
            options={finalAutoQC}
            getOptionLabel={(e) => e}
            renderOption={(props, e, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={icon}
                  size="small"
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {e}
              </li>
            )}
          />
        </Grid>{" "}
        <Grid item xs={12}>
          <MultipleAutocomplete
            labelId="Status"
            id="status"
            name="pushedToFinalTable"
            label="Pushed To Final Table"
            onChange={(_, e) => {
              formik.setFieldValue("pushedToFinalTable", e);
            }}
            isOptionEqualToValue={(option, value) => {
              return option === value;
            }}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  size="small"
                  variant="outlined"
                  label={option}
                  //{...getTagProps({ index })}
                />
              ))
            }
            value={formik.values.pushedToFinalTable}
            placeholder="pushedToFinalTable"
            limitTags={3}
            options={pushedToFinalTable}
            getOptionLabel={(e) => e}
            renderOption={(props, e, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={icon}
                  size="small"
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {e}
              </li>
            )}
          />
        </Grid>{" "}
        <Grid item xs={12}>
          <MultipleAutocomplete
            labelId="Status"
            id="status"
            name="logMonth"
            label="Log Month"
            onChange={(_, e) => {
              formik.setFieldValue("logMonth", e);
            }}
            isOptionEqualToValue={(option, value) => {
              return option === value;
            }}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  size="small"
                  variant="outlined"
                  label={option}
                  //{...getTagProps({ index })}
                />
              ))
            }
            value={formik.values.logMonth}
            placeholder="logMonth"
            limitTags={3}
            options={logMonth}
            getOptionLabel={(e) => e}
            renderOption={(props, e, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={icon}
                  size="small"
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {e}
              </li>
            )}
          />
        </Grid>
        {/* Action Area Start Here */}
        <Grid item xs={12}>
          <Grid
            container
            spacing={2}
            alignItems="center"
            justifyContent="flex-start"
          >
            <Grid item xs="auto">
              <MaterialUIButton
                variant="outlined"
                message="FILTER"
                startIcon={<FilterListOutlinedIcon />}
                onClick={() => formik.handleSubmit()}
              />
            </Grid>
            <Grid item xs="auto">
              <MaterialUIButton
                variant="outlined"
                onClick={() => {
                  reset();
                }}
                message="RESET"
                startIcon={<RestartAltOutlinedIcon />}
              />
            </Grid>
            <Grid item xs="auto">
              <MaterialUIButton
                variant="outlined"
                message="CANCEL"
                startIcon={<EventBusyOutlinedIcon />}
                onClick={() => {
                  JSON.stringify(formik.initialValues) ===
                  JSON.stringify(formik.values)
                    ? props.close()
                    : setShow(true);
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <AlertDialog
          open={show}
          onClose={() => setShow(false)}
          // open={isDeleted}
          title={"Confirmation"}
          // maxWidth={"sm"}
          description={`Do you want to discard the changes ?`}
          action={
            <Grid
              container
              alignItems="center"
              justifyContent="right"
              spacing={2}
              className={classes.alertDialogbtn}
            >
              <Grid item xs={"auto"}>
                <MaterialUIButton
                  variant="outlined"
                  onClick={() => {
                    setShow(false);
                    props.close();
                    reset();
                  }}
                  message="Yes"
                  startIcon={<DoneIcon />}
                />
              </Grid>
              <Grid item xs={"auto"}>
                <MaterialUIButton
                  variant="outlined"
                  onClick={() => {
                    setShow(false);
                  }}
                  message="No"
                  startIcon={<CloseIcon />}
                />
              </Grid>
            </Grid>
          }
        />
        {/* Action Area End Here */}
      </Grid>
    </Box>
    // Advance Filter Form End Here
  );
}

export default AdvanceFilterBau;
